import { render, staticRenderFns } from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto-yek.vue?vue&type=template&id=16df5fde&scoped=true&"
import script from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto-yek.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto-yek.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjakson-hyvaksyntapyynto-yek.vue?vue&type=style&index=0&id=16df5fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df5fde",
  null
  
)

export default component.exports